import { Component } from '@theme/component';

/**
 * Responsive disclosure group: `<details data-responsive>` inside this element are
 * - from 768px: always open and not collapsible (plain content blocks);
 * - below 768px: accordions, closed by default except those with `data-mobile-open`.
 * The details are open in the markup so content stays readable without JavaScript.
 * Used by the footer columns and the "Comprendre" section.
 *
 * @extends {Component}
 */
class AbsolutDetailsGroup extends Component {
  /** @type {AbortController | undefined} */
  #controller;

  connectedCallback() {
    super.connectedCallback();

    this.#controller?.abort();
    this.#controller = new AbortController();
    const { signal } = this.#controller;
    const desktop = window.matchMedia('(min-width: 768px)');

    const apply = () => {
      for (const details of this.querySelectorAll('details[data-responsive]')) {
        if (!(details instanceof HTMLDetailsElement)) continue;
        details.open = desktop.matches || details.hasAttribute('data-mobile-open');
      }
    };

    apply();
    desktop.addEventListener('change', apply, { signal });
    this.addEventListener(
      'click',
      (event) => {
        if (desktop.matches && event.target instanceof Element && event.target.closest('details[data-responsive] > summary')) {
          event.preventDefault();
        }
      },
      { signal }
    );
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#controller?.abort();
  }
}

if (!customElements.get('absolut-details-group')) {
  customElements.define('absolut-details-group', AbsolutDetailsGroup);
}
